import React, { Component  } from 'react';
import '../static/styles/pageLoading.scss'

const loading =  require( '../static/image/loading.gif');

interface Props{
}
interface State{
}
export default class PageLoading extends Component<Props, State>{
    constructor(props){
        super(props);
	    this.state = {}
    }
    render(){
        return(
            <div className= 'page-loading'>
                <div className="loading-content">
	                <img src={loading}/>
	                {/*<p>正在加载</p>*/}
                </div>
            </div>
        )
    }

}
